import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filtered, sorted } from '../features/filter/filterSlice';

const Sidebar = () => {
  const dispatch = useDispatch();
  const { sort, filter } = useSelector((state) => state.filters);

  const handleChange = (e) => {
    if (e.target.type === 'select-one') {
      dispatch(sorted(e.target.value));
    }
    if (e.target.type === 'radio') {
      dispatch(filtered(e.target.value));
    }
  };

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
            value={sort}
            onChange={handleChange}
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-all"
                checked={filter === 'all'}
                value="all"
                className="radio"
                onChange={handleChange}
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-saved"
                checked={filter === 'saved'}
                value="saved"
                className="radio"
                onChange={handleChange}
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
